<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div #chart [id]="id">
  <div [id]="tooltipId" class="sbc-tooltip"></div>
  <div>{{message}}</div>
</div>


<div *ngIf="isDebug">
  <hr/>
  <div>
    Definition:
    <small class="sbc-debug">{{ definition | json}}</small>
  </div>
  <div>
    Sources:
    <small class="sbc-debug">{{ sources | json }}</small>
  </div>
</div>
